import type HttpStatusCode from '@/api/enums/http-status-code';
import type { Ref } from 'vue';
import { ref } from 'vue';

export const useStatusCode = () => ({
  statusCode: ref<HttpStatusCode>() as Ref<HttpStatusCode>,
});
